<script>
  import {
    REQUEST_REPORT_ISSUED_CARDS,
    REQUEST_REPORT_BLOCKED_CARDS,
    REQUEST_REPORT_PASSAGES,
    REQUEST_REPORT_EXTENDED_CARDS,
    REQUEST_REPORT_DENIED_PASSAGES,
    REQUEST_REPORT_PRESENCE,
  } from '@/requests/teacher'
  import ReportsView from "@/views/common/ReportsView";
  import {REPORT_TYPES} from "@/views/common/ReportsView";
  import API from "@/config/api";

  export default {
    extends: ReportsView,
    name: 'TeacherReportsView',
    data() {
      return {
        reportTypes: [
          {
            request: REQUEST_REPORT_ISSUED_CARDS,
            name: 'Выданные карты',
            type: [REPORT_TYPES.withCardTypes, REPORT_TYPES.withCardStatuses],
          },
          {
            request: REQUEST_REPORT_BLOCKED_CARDS,
            name: 'Заблокированные карты',
            type: [],
          },
          {
            request: REQUEST_REPORT_PASSAGES,
            name: 'Проходы',
            type: [REPORT_TYPES.withDates],
          },
          {
            request: REQUEST_REPORT_EXTENDED_CARDS,
            name: 'Продленные карты',
            type: [REPORT_TYPES.withDates],
          },
          {
            request: REQUEST_REPORT_DENIED_PASSAGES,
            name: 'Попытки проходов',
            type: [REPORT_TYPES.withDates, REPORT_TYPES.withCardEventDeniedPassages],
          },
          {
            request: REQUEST_REPORT_PRESENCE,
            name: 'Присутствие в школе на указанное время',
            type: [REPORT_TYPES.withPresence],
          }
        ],
        suggestionsUnit: null,
        suggestionsParentUnit: null,
        downloadReport: API.teacher.reports.download
      }
    },
  }
</script>